<template>
  <v-dialog v-model="isVisible" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="CloseDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Upload clients</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- any button if you want here -->
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12 md6 lg6>
          <v-container fluid>
            <v-file-input
              v-model="selectedFile"
              placeholder="Upload your .vcf file"
              label="File input"
              accept=".vcf"
              prepend-icon="mdi-paperclip"
              color="primary"
            ></v-file-input>
            <v-btn color="primary" dark :disabled="this.selectedFile == null" @click="sendFile">
              <v-icon left>mdi-cloud-upload</v-icon>Upload
            </v-btn>
          </v-container>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isVisible: false,
      selectedFile: null
    };
  },
  methods: {
    OpenDialog() {
      this.isVisible = true;
    },
    CloseDialog() {
      this.isVisible = false;
    },

    sendFile() {
      let myForm = new FormData();
      let mutation = `mutation uploadClients {
                    uploadClients(companyID :"${this.$store.getters.user.companyId}") {
                        name,
                        message,
                        status
                    }
                    }`;

      myForm.append("query", mutation);
      myForm.append("file", this.selectedFile);

      axios
        .post("/graphql", myForm)
        .then(res => {
          let myResult = res.data.data.uploadClients.message;
          if (myResult && myResult === "Import was successful") {
            this.selectedFile = null;
            this.showSuccess(myResult);
          }
        })
        .catch(() => {
          this.showError("Import failed! Try again or contact us!");
        });
    }
  },
  computed: {
    
  }
};
</script>

<style>
</style>